import { render, staticRenderFns } from "./TabelaColuna.vue?vue&type=template&id=c4b0bdae&scoped=true&lang=pug"
import script from "./TabelaColuna.vue?vue&type=script&lang=js"
export * from "./TabelaColuna.vue?vue&type=script&lang=js"
import style0 from "./TabelaColuna.styl?vue&type=style&index=0&id=c4b0bdae&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b0bdae",
  null
  
)

export default component.exports